import { Component, ElementRef, Input, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';

import { TAAConstants } from '../../../../views/constants/taa-constants';
import { PaperStepperComponent } from '../process-paper-request/stepper/paper-stepper.component';
import { AccommsService } from '../../../../views/services/accomms.service';
import { CommonService } from '../../../../views/services/common.service';
import { AccommodationService } from '../../accmgr/services/accommodation.service';
import { AppService } from '../../../../views/services/app.service';
import { AccomSupportService } from '../../common/services/accomsupport.service';



@Component({

    selector: "app-accsupportaccomodations",
    templateUrl: "./accsupportaccomodations.component.html"
})
export class AccsupportAccommodationsComponent implements OnInit {
    public personName: string;
    public taaPin: string;
    public currentRecord: any;
    public user: string = "";
    public savedReq: any;
    public otherAccommodationDesc: string = '';
    frmAccomodation: FormGroup;
    public accommodations: any[];
    public otherAccomsDescError: boolean = false;
    public requiredAccommodation: boolean = false;
    public accommodationsTimings: any[];
    public accommodation: any;
    public accomCat: any;
    public formSubmitted: false;
    public otherAccomm: any;
    public existingAccomms: any;
    public statusCd: string;
    constructor(
        public stepper: PaperStepperComponent,
        public commonService: CommonService,
        public taaConstants: TAAConstants,
        private appService: AppService,
        private accommsService: AccommsService,
        private accommodationService: AccommodationService,
        public fb: FormBuilder
    ) {
        this.frmAccomodation = this.fb.group({
            accommodationsCategories: this.fb.array([]),
            timing: [],
            otherAccommodationDesc: []
        });
    }

    ngOnInit() {
        this.appService.getUserProfile().then(user => this.user = user.userName);
        this.getStatusCode();
        sessionStorage.setItem("testSubmitted", '');
        if (sessionStorage.getItem("currentStudent")) {
            const studentDetails: any = JSON.parse(
                sessionStorage.getItem("currentStudent")
            );
            this.savedReq = studentDetails;
        }
        this.personName = this.savedReq ? this.savedReq.personName : '';
        this.taaPin = this.savedReq ? this.savedReq.taaPin : '';
        Observable.forkJoin(
            this.accommodationService.getAllAccommodation(),
            this.accommodationService.getAccommodationCategory(),
            this.accommodationService.getExistingAccomms(this.stepper.request.requestId),
        ).subscribe(([response, accCatName, ExistingAccomms]) => {
            this.accomCat = accCatName.body;
            const acc: any[] = <Array<any>>response;
            this.existingAccomms = ExistingAccomms;
            const accomms = [];
            this.accommodations = [];

            for (let j = 0; j < this.accomCat.length; j++) {
                if (!accomms[this.accomCat[j].ACCOMMODATION_CATEGORY_NM]) {
                    accomms[this.accomCat[j].ACCOMMODATION_CATEGORY_NM] = {
                        ACCOMMODATION_CATEGORY_NM: this.accomCat[j].ACCOMMODATION_CATEGORY_NM,
                        ACCOMMODATION_CATEGORY_ID: this.accomCat[j].ACCOMMODATION_CATEGORY_ID,
                        ACCOMMODATION_CATEGORY_DS: this.accomCat[j].ACCOMMODATION_CATEGORY_DS,
                        DISPLAY_ORDER_NO: this.accomCat[j].DISPLAY_ORDER_NO,
                        ACCOMMODATION_DS: [],
                        INFORMATION_TX: []
                    };
                }
                for (let i = 0; i < acc.length; i++) {
                    if (acc[i].ACCOMMODATION_CATEGORY_ID === this.accomCat[j].ACCOMMODATION_CATEGORY_ID) {
                        accomms[this.accomCat[j].ACCOMMODATION_CATEGORY_NM].ACCOMMODATION_DS.push({
                            'ACCOMMODATION_DS': acc[i].ACCOMMODATION_DS,
                            'ACCOMMODATION_ID': acc[i].ACCOMMODATION_ID,
                            'checked': false
                        });
                        accomms[this.accomCat[j].ACCOMMODATION_CATEGORY_NM].INFORMATION_TX.push(acc[i].INFORMATION_TX);
                    }
                }
            }


            const combinedArray = [];
            for (const key in accomms) {
                if (accomms.hasOwnProperty(key)) {
                    const obj = {
                        ACCOMMODATION_CATEGORY_NM: accomms[key].ACCOMMODATION_CATEGORY_NM,
                        INFORMATION_TX: accomms[key].INFORMATION_TX,
                        ACCOMMODATION_CATEGORY_ID: accomms[key].ACCOMMODATION_CATEGORY_ID,
                        DISPLAY_ORDER_NO: accomms[key].DISPLAY_ORDER_NO,
                        ACCOMMODATION_DS: accomms[key].ACCOMMODATION_DS,
                        ACCOMMODATION_CATEGORY_DS: accomms[key].ACCOMMODATION_CATEGORY_DS
                    };

                    for (let m = 0; m < obj.ACCOMMODATION_DS.length; m++) {
                        const entry = obj.ACCOMMODATION_DS[m];
                        for (let n = 0; n < this.existingAccomms.length; n++) {
                            const selected_entry = this.existingAccomms[n];
                            if (selected_entry.ACCOMMODATION_ID !== entry.ACCOMMODATION_ID) {
                                continue;
                            }
                            obj.ACCOMMODATION_DS[m].checked = true;
                        }
                    }
                    combinedArray.push(obj);
                }
            }
            this.accommodations = combinedArray;
            let OTHER_ID = null;
            for (const val of this.accommodations) {
                if (val.ACCOMMODATION_CATEGORY_DS.includes('Other')) {
                    OTHER_ID = val.ACCOMMODATION_DS

                    [0].ACCOMMODATION_ID;
                }
            }
            if (OTHER_ID) {
                for (const key2 in this.existingAccomms) {
                    if (this.existingAccomms.hasOwnProperty(key2)) {
                        const entry = this.existingAccomms[key2];
                        if (entry.ACCOMMODATION_ID === OTHER_ID) {
                            this.otherAccommodationDesc = entry.OTHER_DS;
                        }
                    }
                }
            }
        });

    }

    saveAccommodationData(proceed: boolean): void {
        const selectedAccomms = [];
        let accommValidation = false;
        const otherAccomms = !this.regexTest(this.otherAccommodationDesc, 500);

        for (const val of this.accommodations) {
            for (const iRow in val.ACCOMMODATION_DS) {
                if (val.ACCOMMODATION_CATEGORY_DS.includes('Other')) {
                    continue;
                }
                if (val.ACCOMMODATION_DS[iRow].checked) {
                    accommValidation = true;
                    selectedAccomms.push({
                        ACCOMMODATION_CD: val.ACCOMMODATION_CATEGORY_NM,
                        ACCOMMODATION_ID: val.ACCOMMODATION_DS[iRow].ACCOMMODATION_ID,
                        DISPLAY_ORDER_NO: val.DISPLAY_ORDER_NO,
                        ACCOMMODATION_DS: val.ACCOMMODATION_DS[iRow].ACCOMMODATION_DS,
                        INFORMATION_TX: val.INFORMATION_TX[iRow],
                        checked: val.ACCOMMODATION_DS[iRow].checked
                    });

                }
            }
        }
        // Validation 
        if (!accommValidation && this.otherAccommodationDesc === '') {
            this.requiredAccommodation = true;
            return;
        }
        this.requiredAccommodation = false;
        if (otherAccomms && this.otherAccommodationDesc !== '') {
            this.otherAccomsDescError = true;
            return;
        }
        this.otherAccomsDescError = false;

        if (this.otherAccommodationDesc !== '') {
            let otherAcc = {};
            for (const key in this.accommodations) {
                if (this.accommodations[key].ACCOMMODATION_CATEGORY_DS.includes('Other')) {
                    otherAcc = {
                        ACCOMMODATION_CD: this.accommodations[key].ACCOMMODATION_CATEGORY_NM,
                        ACCOMMODATION_ID: this.accommodations[key].ACCOMMODATION_DS[0].ACCOMMODATION_ID,
                        DISPLAY_ORDER_NO: this.accommodations[key].DISPLAY_ORDER_NO,
                        otherDesc: this.otherAccommodationDesc.trim(),
                        // INFORMATION_TX: null,
                        ACCOMMODATION_DS: this.accommodations[key].ACCOMMODATION_DS[0].ACCOMMODATION_DS,
                        checked: true
                    };
                }
            }
            selectedAccomms.push(otherAcc);
        }

        const request: any = {
            requestId: this.stepper.request.requestId,
            personId: this.stepper.request.personId,
            selectedAccommodations: selectedAccomms
        };
        this.saveAccomms(request, proceed);
    }

    regexTest(str, length) {
        if (_.isEmpty(_.toString(str))) {
            return false;
        }
        if (str.length > length) {
            return false;
        }
        const pattern = /^[a-zA-Z0-9\.\s\,\'\:\;]{1,500}$/;
        const regex = new RegExp(pattern);
        return regex.test(str);
    }

    saveAccomms = (request, proceed) => {
        this.accommodationService.saveAccommodations(request).subscribe((data: any) => {
            if (proceed) {
                sessionStorage.setItem("accomSubmitted", 'true');
                this.stepper.goToNextStep();
            }
            this.formSubmitted = false;
        });
    }

    getStatusCode() {
        this.accommsService.getInternalRequests(this.stepper.request.requestId).subscribe(data => {
            this.accommsService.getRequestedStatusCode((data as any).REQUEST_STATUS_CODE_ID).subscribe(success => {
                this.statusCd = (success as any).STATUS_CD;
            },
            );
        });
    }
    getPreviousRecordDetails = () => {
        this.stepper.goToPrevStep();
    }
}






// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/accsupportaccomodations/accsupportaccomodations.component.ts